var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { quadraticToPoints } from '../../pathUtils';
var SW = 1.7;
export function L(app, parent, x, y, dx, dy, color, sw) {
    if (sw === void 0) { sw = SW; }
    parent.add(app.line({
        x: x,
        y: y,
        x2: dx,
        y2: dy,
        stroke: color,
        strokeWidth: sw,
        lineCap: 'round',
        lineJoin: 'round',
        listening: false,
    }));
}
export function R(app, parent, x, y, w, h, color, sw, cr, fill) {
    if (sw === void 0) { sw = SW; }
    if (cr === void 0) { cr = 2.5; }
    if (fill === void 0) { fill = null; }
    parent.add(app.roundedRect({
        x: x,
        y: y,
        width: w,
        height: h,
        cornerRadius: cr,
        fill: fill,
        stroke: color,
        strokeWidth: sw,
        listening: false,
    }));
}
/** Circle centered at (cx, cy) — compensates for top-left circle origin. */
export function C(app, parent, cx, cy, r, color, sw, fill) {
    if (sw === void 0) { sw = SW; }
    if (fill === void 0) { fill = null; }
    parent.add(app.circle({
        x: cx - r,
        y: cy - r,
        radius: r,
        fill: fill,
        stroke: fill ? null : color,
        strokeWidth: fill ? 0 : sw,
        listening: false,
    }));
}
export function E(app, parent, cx, cy, rx, ry, color, sw) {
    if (sw === void 0) { sw = SW; }
    parent.add(app.ellipse({
        x: cx - rx,
        y: cy - ry,
        radiusX: rx,
        radiusY: ry,
        fill: null,
        stroke: color,
        strokeWidth: sw,
        listening: false,
    }));
}
export function poly(app, parent, points, color, sw, fill) {
    if (sw === void 0) { sw = SW; }
    if (fill === void 0) { fill = null; }
    parent.add(app.polygon({ points: points, fill: fill, stroke: color, strokeWidth: sw, listening: false }));
}
export function pline(app, parent, points, color, sw) {
    if (sw === void 0) { sw = SW; }
    parent.add(app.polyline({
        points: points,
        fill: null,
        stroke: color,
        strokeWidth: sw,
        lineCap: 'round',
        lineJoin: 'round',
        listening: false,
    }));
}
/** Continuous cloud outline (Visio-style). */
export function drawCloudShape(app, parent, cx, cy, color) {
    var e_1, _a;
    var bumps = [
        { x: cx - 10, y: cy + 3, r: 6.5 },
        { x: cx - 2, y: cy - 5, r: 7.5 },
        { x: cx + 9, y: cy - 2, r: 7 },
        { x: cx + 11, y: cy + 5, r: 5.5 },
        { x: cx, y: cy + 7, r: 6 },
    ];
    try {
        for (var bumps_1 = __values(bumps), bumps_1_1 = bumps_1.next(); !bumps_1_1.done; bumps_1_1 = bumps_1.next()) {
            var b = bumps_1_1.value;
            C(app, parent, b.x, b.y, b.r, color, 1.55);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (bumps_1_1 && !bumps_1_1.done && (_a = bumps_1.return)) _a.call(bumps_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
export function drawGlobe(app, parent, cx, cy, color) {
    C(app, parent, cx, cy, 13, color, 1.75);
    E(app, parent, cx, cy, 6, 13, color, 1.35);
    L(app, parent, cx - 13, cy, 26, 0, color, 1.35);
    L(app, parent, cx - 11, cy - 6, 22, 0, color, 1.15);
    L(app, parent, cx - 11, cy + 6, 22, 0, color, 1.15);
}
export function drawRouterHex(app, parent, cx, cy, size, color) {
    var e_2, _a;
    var r = size * 0.3;
    var hex = [];
    for (var i = 0; i < 6; i++) {
        var a = (Math.PI / 3) * i - Math.PI / 6;
        hex.push(cx + r * Math.cos(a), cy + 2 + r * Math.sin(a));
    }
    poly(app, parent, hex, color, 1.85);
    C(app, parent, cx, cy + 2, 3.4, color, 1, color);
    try {
        for (var _b = __values([-1, 1]), _c = _b.next(); !_c.done; _c = _b.next()) {
            var sign = _c.value;
            pline(app, parent, quadraticToPoints(cx + sign * 5, cy - 8, cx + sign * 13, cy - 16, cx + sign * 3, cy - 19, 7), color, 1.45);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
export function drawServerRack(app, parent, cx, cy, color) {
    R(app, parent, cx - 13, cy - 15, 26, 30, color, 1.75, 3.5);
    for (var i = 0; i < 3; i++) {
        var y = cy - 11 + i * 8.5;
        R(app, parent, cx - 9, y, 14, 5.5, color, 1.15, 1.2);
        C(app, parent, cx + 8.5, y + 2.75, 1.5, color, 1, i === 0 ? color : null);
    }
}
export function drawSwitchBody(app, parent, cx, cy, color) {
    R(app, parent, cx - 16, cy - 9, 32, 18, color, 1.75, 3.5);
    for (var i = 0; i < 8; i++) {
        R(app, parent, cx - 14 + i * 3.6, cy - 3, 2.6, 7, color, 0.95, 0.5, i % 2 === 0 ? color : null);
    }
    L(app, parent, cx - 13, cy - 12, 26, 0, color, 1.25);
    C(app, parent, cx + 12, cy - 12, 1.4, color, 1, color);
}
export function drawMonitor(app, parent, cx, cy, color) {
    R(app, parent, cx - 14, cy - 13, 28, 18, color, 1.75, 3);
    R(app, parent, cx - 11, cy - 10, 22, 12, color, 1.15, 1.5);
    L(app, parent, cx, cy + 5, 0, 5, color, 1.7);
    L(app, parent, cx - 8, cy + 11, 16, 0, color, 1.7);
}
export function drawShield(app, parent, cx, cy, color, mark) {
    if (mark === void 0) { mark = 'check'; }
    poly(app, parent, [cx, cy - 15, cx + 12, cy - 9, cx + 11, cy + 3, cx, cy + 15, cx - 11, cy + 3, cx - 12, cy - 9], color, 1.8);
    if (mark === 'check') {
        pline(app, parent, [cx - 5, cy + 1, cx - 1, cy + 6, cx + 7, cy - 5], color, 1.7);
    }
    else if (mark === 'eye') {
        E(app, parent, cx, cy, 5, 3.2, color, 1.35);
        C(app, parent, cx, cy, 1.8, color, 1, color);
    }
    else if (mark === 'lock') {
        R(app, parent, cx - 4, cy - 1, 8, 7, color, 1.35, 1.2);
        pline(app, parent, [cx - 3, cy - 1, cx - 3, cy - 5, cx + 3, cy - 5, cx + 3, cy - 1], color, 1.35);
    }
}
export function drawCylinder(app, parent, cx, cy, color) {
    var w = 22;
    var h = 16;
    var rx = w / 2;
    var ry = 4.5;
    E(app, parent, cx, cy - h / 2, rx, ry, color, 1.55);
    L(app, parent, cx - rx, cy - h / 2, 0, h, color, 1.55);
    L(app, parent, cx + rx, cy - h / 2, 0, h, color, 1.55);
    E(app, parent, cx, cy + h / 2, rx, ry, color, 1.55);
    E(app, parent, cx, cy - 1, rx, ry * 0.85, color, 1.15);
}
export function drawWifiArcs(app, parent, cx, cy, color) {
    var e_3, _a;
    C(app, parent, cx, cy + 8, 2.4, color, 1, color);
    try {
        for (var _b = __values([7, 11, 15]), _c = _b.next(); !_c.done; _c = _b.next()) {
            var r = _c.value;
            pline(app, parent, quadraticToPoints(cx - r, cy + 4, cx, cy + 4 - r * 0.85, cx + r, cy + 4, 10), color, 1.55);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_3) throw e_3.error; }
    }
}
export function drawLoadBalancer(app, parent, cx, cy, color) {
    var e_4, _a;
    R(app, parent, cx - 5, cy - 13, 10, 9, color, 1.6, 2);
    L(app, parent, cx, cy - 4, 0, 5, color, 1.55);
    L(app, parent, cx - 11, cy + 2, 22, 0, color, 1.55);
    try {
        for (var _b = __values([-11, 0, 11]), _c = _b.next(); !_c.done; _c = _b.next()) {
            var ox = _c.value;
            L(app, parent, cx + ox, cy + 2, 0, 8, color, 1.45);
            C(app, parent, cx + ox, cy + 12, 2.2, color, 1.2);
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_4) throw e_4.error; }
    }
}
export function drawZoneBox(app, parent, cx, cy, color) {
    R(app, parent, cx - 15, cy - 11, 30, 22, color, 1.55, 4);
    parent.add(app.roundedRect({
        x: cx - 11,
        y: cy - 7,
        width: 22,
        height: 14,
        cornerRadius: 2.5,
        fill: null,
        stroke: color,
        strokeWidth: 1.2,
        dash: [3.5, 2.5],
        listening: false,
    }));
}
/** Draw a standard network glyph centered in a size×size box. */
